import type { TranslationDictionary } from "./types";

export const VI_DICTIONARY: TranslationDictionary = {
    "app.newTask": "Mới",
    "app.newTaskAria": "Trò chuyện mới",
    "sidebar.searchPlaceholder": "Tìm kiếm lời nhắc hoặc Task ID",
    "sidebar.filters": "Bộ lọc tác vụ",
    "sidebar.allRatios": "Tất cả tỷ lệ",
    "sidebar.allOrientations": "Tất cả hướng",
    "sidebar.allModes": "Tất cả chế độ",
    "sidebar.allResolutions": "Tất cả độ phân giải",
    "sidebar.allStatuses": "Tất cả trạng thái",
    "sidebar.activeTasks": "Tác vụ đang chạy",
    "sidebar.topAnchors": "Điều hướng thời gian phía trên",
    "sidebar.bottomAnchors": "Điều hướng thời gian phía dưới",
    "sidebar.resize": "Thay đổi kích thước thanh bên",
    "batch.selected": "0 đã chọn",
    "batch.selectedCount": "{count} đã chọn",
    "batch.selectCurrentGroup": "Chọn tất cả trong nhóm",
    "batch.archivedCount": "Đã lưu trữ {count} cuộc trò chuyện",
    "batch.archiveFailed": "Lưu trữ hàng loạt không thành công",
    "batch.runningCannotDeleteSelected": "Các tác vụ đã chọn đang chạy và không thể xóa",
    "batch.deleteTitle": "Xóa cuộc trò chuyện {count}?",
    "batch.deleteMessage": "Thao tác này cũng sẽ xóa các file ảnh cục bộ.",
    "batch.deleteSkippedDetail": "{count} tác vụ đang chạy sẽ được giữ lại",
    "batch.deleteSkippedSuffix": ", {count} tác vụ đang chạy không bị xóa",
    "batch.deletedCount": "Đã xóa {count} cuộc trò chuyện{skipped}",
    "batch.deleteFailed": "Xóa hàng loạt không thành công",
    "batch.cancelTasksShortcut": "Hủy tác vụ",
    "batch.cancelSelected": "Hủy tác vụ",
    "batch.noActiveSelected": "Các tác vụ đã chọn không còn chạy hoặc chờ",
    "batch.cancelTitle": "Hủy {count} tác vụ?",
    "batch.cancelMessage": "Tác vụ đang chạy sẽ dừng và tác vụ đang chờ sẽ rời hàng đợi. Lịch sử vẫn được giữ lại.",
    "batch.cancelDetail": "Đang chạy {running} · đang chờ {waiting}",
    "batch.cancelConfirm": "Hủy tác vụ",
    "batch.cancelResult": "Đã hủy {cancelled}, bỏ qua {skipped}, thất bại {failed}",
    "batch.cancelFailed": "Hủy hàng loạt thất bại",
    "action.archive": "Lưu trữ",
    "action.delete": "Xóa",
    "action.cancel": "Hủy",
    "action.edit": "Chỉnh sửa",
    "action.clear": "Xóa",
    "action.paste": "Dán",
    "action.find": "Tìm",
    "action.replace": "Thay thế",
    "action.close": "Đóng",
    "action.confirm": "Xác nhận",
    "action.confirmQuestion": "Xác nhận hành động?",
    "action.refresh": "Làm mới",
    "action.save": "Lưu",
    "action.add": "Thêm",
    "action.new": "Mới",
    "action.import": "Nhập",
    "action.export": "Xuất",
    "queue.empty": "Không có hàng đợi",
    "queue.emptyAria": "Trạng thái hàng đợi: không có tác vụ đang chờ",
    "queue.jumpTitle": "Chuyển đến tác vụ đang chạy",
    "queue.emptyTitle": "Không có tác vụ đang chờ",
    "queue.channel": "Kênh {count}",
    "queue.availableChannels": "Các kênh có sẵn {usable}/{total}",
    "queue.dispatching": "Đang lên lịch · chờ đợi {waiting}",
    "queue.runningWaiting": "Đang chạy {running} · chờ {waiting}",
    "queue.statusLabel": "Trạng thái hàng đợi: {text} · {channelText}. Bấm để chuyển đến tác vụ đang chạy",
    "queue.runningActions": "Hành động cho tác vụ đang chạy",
    "queue.waitingActions": "Hành động cho tác vụ đang chờ",
    "queue.cancelRunning": "Hủy",
    "queue.cancelRunningTitle": "Hủy tác vụ đang chạy",
    "queue.dragWaiting": "Kéo để sắp xếp lại tác vụ đang chờ",
    "queue.dragSort": "Kéo để sắp xếp",
    "queue.moveUp": "Lên",
    "queue.moveUpTitle": "Di chuyển tác vụ đang chờ lên",
    "queue.moveDown": "Xuống",
    "queue.moveDownTitle": "Di chuyển tác vụ đang chờ xuống",
    "queue.promote": "Lên đầu",
    "queue.promoteTitle": "Đưa tác vụ đang chờ lên đầu",
    "queue.promoteFailed": "Di chuyển lên đầu không thành công",
    "queue.deleteWaitingShort": "Del",
    "queue.deleteWaitingTitle": "Xóa tác vụ đang chờ",
    "queue.deleteWaitingTitleConfirm": "Xóa tác vụ đang chờ?",
    "queue.deleteWaitingMessage": "Điều này loại bỏ nó khỏi danh sách hàng đợi và lịch sử.",
    "queue.deleteQueuedFailed": "Không thể xóa tác vụ đã xếp hàng đợi",
    "queue.queuedDeleted": "Đã xóa tác vụ xếp hàng đợi",
    "queue.cancelRunningConfirm": "Hủy tác vụ",
    "queue.cancelRunningTitleConfirm": "Hủy tác vụ đang chạy?",
    "queue.cancelRunningMessage": "Tác vụ hiện tại sẽ dừng. Lịch sử sẽ được giữ lại.",
    "queue.cancelRunningFailed": "Không hủy được tác vụ",
    "queue.runningCancelled": "Tác vụ đã bị hủy",
    "queue.reorderFailed": "Không thể sắp xếp lại hàng đợi",
    "queue.realtimeUpdateFailed": "Không cập nhật được trạng thái trực tiếp",
    "queue.realtimeDisconnected": "Kết nối trạng thái trực tiếp bị mất. Làm mới trang để phục hồi.",
    "queue.readFailed": "Không thể tải hàng đợi",
    "status.waiting": "Đang chờ",
    "status.shownActiveTasks": "Hiển thị các tác vụ đang chạy",
    "status.jsonCopied": "Đã sao chép JSON",
    "taskStatus.submitting": "Đang gửi",
    "taskStatus.running": "Đang tạo",
    "taskStatus.runningWithElapsed": "Đang tạo · {elapsed}",
    "taskStatus.completed": "Đã hoàn thành",
    "taskStatus.partialFailed": "Thất bại một phần",
    "taskStatus.failed": "Thất bại",
    "taskStatus.queued": "Đã xếp hàng",
    "taskStatus.unknown": "Trạng thái không xác định",
    "taskStatus.task": "Tác vụ",
    "taskStatus.connectionInterrupted": "Kết nối bị gián đoạn",
    "taskStatus.lastFailed": "Thất bại lần cuối",
    "taskStatus.waitingRetry": "{reason}, chờ thử lại (lần {attempt}/{max})",
    "taskStatus.retrying": "{reason}, đang thử lại (lần {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "Đã thử {attempt}/{max}, không thể thử lại được",
    "taskStatus.manualRetryAvailable": "Đã dừng; bạn có thể thử lại thủ công các ảnh bị lỗi",
    "taskStatus.waitingRetryShort": "Đang chờ thử lại",
    "taskStatus.retryingShort": "Đang thử lại",
    "taskStatus.nonRetryableShort": "Không thể thử lại",
    "taskStatus.manualRetryShort": "Thử lại thủ công",
    "taskStatus.stoppedShort": "Đã dừng",
    "taskStatus.runtime": "Thời lượng {duration}",
    "taskStatus.runtimeCompleted": "Thời lượng {duration} · đã hoàn thành {time}",
    "taskStatus.completedAt": "Đã hoàn thành {time}",
    "taskCard.count": "{count} hình ảnh",
    "taskCard.successCount": "{count} thành công",
    "taskCard.failedCount": "thất bại {count}",
    "taskCard.runningCount": "đang tạo {count}",
    "taskCard.waitingCount": "đang chờ {count}",
    "taskCard.textToImageThumb": "Hình thu nhỏ tác vụ chuyển văn bản thành hình ảnh",
    "taskCard.imageToImageThumb": "Hình thu nhỏ tác vụ chuyển hình ảnh thành hình ảnh",
    "taskCard.failedThumb": "Tác vụ thất bại",
    "taskCard.textBadge": "T",
    "taskMode.edit": "Chỉnh sửa",
    "taskMode.generate": "Tạo",
    "document.generatingQueue": "Đang tạo · hàng đợi {total}",
    "document.queuedWaiting": "Đang xếp hàng · đang chờ {count}",
    "runFeedback.editing": "Chỉnh sửa",
    "runFeedback.generating": "Đang tạo",
    "runFeedback.status": "{action}, đã trôi qua {elapsed}",
    "footer.archive": "Lưu trữ",
    "footer.archiveCount": "Lưu trữ {count}",
    "footer.historyLibrary": "Lịch sử",
    "historyLibrary.openFull": "Mở thư viện lịch sử đầy đủ",
    "history.documentTitle": "Lịch sử - iLab CONJURE",
    "history.back": "Quay lại trình tạo",
    "history.homeAria": "Quay lại trang tạo ảnh iLab CONJURE",
    "history.backToGenerator": "Quay lại trang tạo ảnh",
    "history.title": "Lịch sử",
    "history.loading": "Đang tải",
    "history.total": "{total} tác vụ · {archived} đã lưu trữ",
    "history.search": "Tìm kiếm",
    "history.searchPlaceholder": "Tìm kiếm lời nhắc hoặc Task ID",
    "history.clear": "Xóa",
    "history.favorites": "Yêu thích",
    "history.onlyFavorites": "Chỉ xem mục yêu thích",
    "history.favoriteTask": "Thêm vào yêu thích",
    "history.unfavoriteTask": "Bỏ khỏi yêu thích",
    "history.tags": "Nhãn",
    "history.untagged": "Chưa gắn nhãn",
    "history.manageTags": "Quản lý nhãn",
    "history.createTag": "Tạo nhãn",
    "history.renameTag": "Đổi tên",
    "history.deleteTag": "Xóa",
    "history.deleteTagAffected": "Xóa (ảnh hưởng {count} tác vụ)",
    "history.addTag": "Thêm nhãn",
    "history.removeTag": "Gỡ nhãn",
    "history.favoriteSelected": "Yêu thích",
    "history.unfavoriteSelected": "Bỏ yêu thích",
    "history.organizationFailed": "Không thể cập nhật mục yêu thích hoặc nhãn",
    "history.tagNameConflict": "Tên nhãn này đã tồn tại",
    "history.noTags": "Chưa có nhãn",
    "history.backendRestartRequired": "Tính năng thư viện lịch sử đã được cập nhật. Hãy khởi động lại ứng dụng rồi thử lại.",
    "history.export": "Xuất",
    "history.exportImagesOnly": "Chỉ hình ảnh",
    "history.exportImagesWithPrompts": "Hình ảnh + câu lệnh",
    "history.exportPreparing": "Đang chuẩn bị bản xuất…",
    "history.exportStarted": "Đã bắt đầu tải xuống",
    "history.exportSummary": "{taskCount} tác vụ · {imageCount} hình ảnh",
    "history.exportFailed": "Xuất thất bại",
    "history.closeExport": "Đóng lựa chọn xuất",
    "history.type": "Loại",
    "history.allTypes": "Tất cả loại",
    "history.type.textToImage": "Văn bản thành ảnh",
    "history.type.imageToImage": "Ảnh thành ảnh",
    "history.month": "Tháng",
    "history.status": "Trạng thái",
    "history.promptMode": "Chế độ lời nhắc",
    "history.size": "Kích thước",
    "history.quality": "Chất lượng",
    "history.ratio": "Tỷ lệ",
    "history.orientation": "Hướng",
    "history.backend": "Backend",
    "history.provider": "Provider",
    "history.archived": "Đã lưu trữ",
    "history.all": "Tất cả",
    "history.allMonths": "Tất cả các tháng",
    "history.allStatuses": "Tất cả trạng thái",
    "history.allPromptModes": "Tất cả các chế độ",
    "history.allSizes": "Tất cả các kích cỡ",
    "history.allQualities": "Tất cả chất lượng",
    "history.allRatios": "Tất cả các tỷ lệ",
    "history.ratioOther": "Khác",
    "history.allOrientations": "Tất cả hướng",
    "history.allBackends": "Tất cả backend",
    "history.allProviders": "Tất cả provider",
    "history.unarchived": "Chưa lưu trữ",
    "history.archivedOnly": "Đã lưu trữ",
    "history.tasksAria": "Tác vụ lịch sử",
    "history.taskListTitle": "Tác vụ lịch sử",
    "history.browseNewest": "Duyệt mới nhất trước",
    "history.view": "Xem",
    "history.grid": "Lưới",
    "history.list": "Danh sách",
    "history.sort": "Sắp xếp",
    "history.newest": "Mới nhất đầu tiên",
    "history.oldest": "Cũ nhất đầu tiên",
    "history.refresh": "Làm mới",
    "history.selectedCount": "{count} tác vụ đã chọn",
    "history.confirmDelete": "Xác nhận xóa",
    "history.detail": "Chi tiết tác vụ",
    "history.detailTitle": "Tác vụ lịch sử",
    "history.closeDetail": "Đóng chi tiết tác vụ",
    "history.resizeFilters": "Thay đổi kích thước thanh bên bộ lọc",
    "history.resizeDetail": "Thay đổi kích thước ngăn chi tiết",
    "history.detailEmpty": "Chọn một tác vụ lịch sử để xem chi tiết",
    "history.loadingDetail": "Đang tải chi tiết...",
    "history.loadMore": "Tải thêm",
    "history.loadingMore": "Đang tải...",
    "history.noMore": "Không còn tác vụ nào nữa",
    "history.loadFailed": "Tải không thành công. Làm mới hoặc tiếp tục cuộn để thử lại",
    "history.summaryFailed": "Không tải được bản tóm tắt",
    "history.tasksFailed": "Không tải được tác vụ",
    "history.detailFailed": "Không thể tải chi tiết",
    "history.noMatches": "Không có tác vụ phù hợp",
    "history.loadedCount": "{count} đã tải",
    "history.windowNotice": "Danh sách hiển thị giới hạn ở {count} tác vụ; cuộn lên hoặc xuống để tải lại các tác vụ liền kề khi cần.",
    "history.selectTask": "Chọn tác vụ",
    "history.viewing": "Đang xem",
    "history.noPreview": "Không có hình ảnh xem trước",
    "history.downloadAll": "Tải xuống ZIP",
    "history.downloadImage": "Tải xuống hình ảnh",
    "history.downloadSelected": "Tải xuống mục đã chọn",
    "history.deleteUnselected": "Xóa mục chưa chọn",
    "history.confirmDeleteUnselected": "Xác nhận xóa bỏ chọn",
    "history.selected": "Đã chọn",
    "history.select": "chọn",
    "history.downloadIndex": "Tải xuống {index}",
    "history.addReference": "Thêm ảnh tham khảo",
    "history.outputActions": "Hành động hình ảnh kết quả",
    "history.inputReferences": "Tham chiếu đầu vào",
    "history.inputReferenceIndex": "Tham chiếu đầu vào {index}",
    "history.copyPrompt": "Sao chép lời nhắc",
    "history.copyPrompts": "Sao chép lời nhắc",
    "history.copyPromptShort": "Sao chép",
    "history.copyPromptPanel": "Sao chép {title}",
    "history.copyOutputPromptPanel": "Sao chép lời nhắc đã chỉnh của ảnh {index}",
    "history.copyTaskIds": "Sao chép Task ID",
    "history.reuseTask": "Xem trong trình tạo",
    "history.downloadTask": "Tải xuống",
    "history.downloadSelectedTasks": "Tải xuống hàng loạt",
    "history.contextMenuLabel": "Menu ngữ cảnh tác vụ lịch sử",
    "history.promptCopied": "Đã sao chép lời nhắc",
    "history.promptsCopied": "Sao chép lời nhắc từ tác vụ {count}",
    "history.taskIdsCopied": "Đã sao chép Task ID {count}",
    "history.promptCopiedShort": "Đã sao chép",
    "history.promptCopyFailed": "Không sao chép được lời nhắc",
    "history.promptCopyFailedShort": "thất bại",
    "history.noPrompt": "Tác vụ này không có lời nhắc để sao chép",
    "history.noPromptShort": "trống",
    "history.downloadStarted": "Đã bắt đầu tải xuống",
    "history.batchDownloadStarted": "Đã bắt đầu tải xuống các tác vụ {count}",
    "history.noDownloadableOutputs": "Không có hình ảnh có thể tải xuống",
    "history.confirmDeleteSelected": "Xác nhận đã chọn xóa",
    "history.openPreview": "Mở bản xem trước",
    "history.closePreview": "Đóng bản xem trước",
    "history.untitled": "Không có tiêu đề",
    "history.promptCompare": "So sánh lời nhắc",
    "history.promptOriginal": "Lời nhắc ban đầu",
    "history.promptSubmitted": "Lời nhắc được tối ưu hóa",
    "history.promptRevised": "Kết quả sửa đổi",
    "history.outputRevisedPromptTitle": "Hình ảnh {index} đã sửa lại lời nhắc",
    "history.outputRevisedPromptNotice": "Mỗi hình ảnh có lời nhắc sửa đổi riêng bên dưới hình ảnh.",
    "history.promptEmpty": "Không có nội dung",
    "history.promptMode.strict": "Giữ sát lời nhắc",
    "history.promptMode.original": "Bản gốc",
    "history.promptMode.off": "Sáng tạo",
    "history.quality.high": "Cao",
    "history.quality.medium": "Trung bình",
    "history.quality.low": "Thấp",
    "history.quality.auto": "Tự động",
    "footer.batch": "Lô",
    "footer.storage": "Lưu trữ",
    "footer.apiStatus": "Trạng thái API: OK",
    "footer.version": "Phiên bản {version}",
    "footer.versionInfo": "Thông tin phiên bản",
    "footer.versionLoading": "Phiên bản...",
    "footer.updateBadge": "Đã có phiên bản mới",
    "footer.updateAvailable": "Phiên bản mới {version}",
    "version.title": "Phiên bản & Cập nhật",
    "version.loading": "Đọc trạng thái phiên bản",
    "version.current": "Phiên bản hiện tại",
    "version.latest": "Phiên bản mới nhất",
    "version.source": "Thời gian chạy",
    "version.sourcePortable": "Gói di động",
    "version.sourceStandard": "Ứng dụng tiêu chuẩn",
    "version.sourceSource": "Kiểm tra nguồn",
    "version.upToDate": "Bạn đã ở phiên bản mới nhất",
    "version.updateAvailable": "Phiên bản {version} có sẵn. Đóng cửa sổ máy chủ WebUI, sau đó chạy trình cập nhật để nâng cấp.",
    "version.standardUpdateAvailable": "Phiên bản {version} có sẵn. Tải xuống gói tiêu chuẩn mới, sau đó thoát khỏi ứng dụng này và cài đặt nó lên gói cũ.",
    "version.standardManualInstall": "Ứng dụng tiêu chuẩn tải xuống gói cài đặt mới; tự động thay thế vẫn còn hạn chế ở các gói di động.",
    "version.noUpdater": "Thời gian chạy này không phải là gói di động nên trình cập nhật không thể tự động khởi động.",
    "version.openUpdater": "Bắt đầu cập nhật",
    "version.release": "Xem bản phát hành",
    "version.updaterStarted": "Trình cập nhật đã bắt đầu. Đóng cửa sổ máy chủ WebUI hiện tại, sau đó làm theo lời nhắc của trình cập nhật.",
    "version.updaterFailed": "Không thể khởi động trình cập nhật. Chạy tập lệnh cập nhật từ gói theo cách thủ công.",
    "version.onboardingTitle": "0.5.5 thêm các gói ứng dụng tiêu chuẩn",
    "version.onboardingStatus": "Bạn đã nâng cấp lên {version}. Bạn có thể tiếp tục sử dụng gói di động hoặc chuyển sang gói ứng dụng tiêu chuẩn.",
    "version.onboardingBody": "Bản phát hành này bổ sung các gói macOS DMG và Windows App ZIP. Người dùng mới nên sử dụng gói tiêu chuẩn; gói di động hiện tại vẫn hoạt động.",
    "version.onboardingDataPortable": "Dữ liệu hiện tại được giữ trong thư mục data/ của gói portable này.",
    "version.onboardingStandardData": "Ứng dụng tiêu chuẩn lưu trữ dữ liệu trong thư mục dữ liệu ứng dụng hệ thống: Hỗ trợ ứng dụng macOS / Windows %APPDATA%.",
    "version.onboardingMigration": "Khi chuyển sang ứng dụng tiêu chuẩn, hãy sử dụng trợ lý di chuyển để sao chép dữ liệu cũ. Nó sẽ không di chuyển hoặc ghi đè lên dữ liệu gốc.",
    "version.standardDownload": "Tải xuống ứng dụng tiêu chuẩn",
    "version.continuePortable": "Tiếp tục dùng gói portable",
    "version.dismissOnboarding": "Không hiển thị lại",
    "version.dismissFailed": "Không thể lưu trạng thái thông báo này. Hãy thử lại sau.",
    "notifications.title": "Thông báo",
    "notifications.unread": "Thông báo, {count} chưa đọc",
    "notifications.unreadSummary": "{count} chưa đọc",
    "notifications.empty": "Không có thông báo tác vụ",
    "notifications.taskFailed": "Tác vụ thất bại",
    "notifications.taskPartial": "Tác vụ đã hoàn thành một phần",
    "notifications.taskCompleted": "Tác vụ đã hoàn thành",
    "notifications.generationFailed": "Tạo ảnh thất bại",
    "notifications.successCount": "{count} đã thành công",
    "notifications.resultAvailable": "Kết quả có sẵn",
    "notifications.failedCount": "{count} thất bại",
    "notifications.systemUnsupported": "Trình duyệt này không hỗ trợ thông báo hệ thống",
    "notifications.systemBlocked": "Thông báo hệ thống bị trình duyệt chặn. Kích hoạt chúng trong cài đặt trình duyệt.",
    "notifications.systemDenied": "Thông báo hệ thống chưa được bật",
    "notifications.systemEnabled": "Đã bật thông báo hệ thống",
    "notifications.taskMissing": "Tác vụ không tồn tại hoặc đã bị xóa",
    "theme.label": "Chủ đề",
    "theme.system": "Tự động",
    "theme.light": "Sáng",
    "theme.dark": "Tối",
    "language.label": "Ngôn ngữ giao diện",
    "language.zh": "中",
    "language.zhCN": "简体中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "language.vi": "Tiếng Việt",
    "auth.label": "Nguồn xác thực",
    "auth.checking": "Kiểm tra xác thực",
    "auth.missingCodexSession": "Không phát hiện thấy phiên Codex nào",
    "auth.switchFailed": "Không thể chuyển đổi nguồn xác thực",
    "auth.sourceUnavailable": "{source} không khả dụng",
    "auth.notActive": "Không hoạt động",
    "api.settings": "Cài đặt hệ thống",
    "api.provider": "Provider API",
    "imageInput.title": "Hình ảnh",
    "imageInput.uploadAria": "Nhấp, thả hoặc dán hình ảnh và tệp",
    "imageInput.uploadFull": "Nhấp, thả hoặc dán hình ảnh và tệp",
    "imageInput.uploadCompact": "Thêm đầu vào",
    "imageInput.uploadSubtitle": "Hỗ trợ hình ảnh và tệp tham chiếu Responses",
    "imageInput.recent": "Tải lên gần đây",
    "imageInput.recentBadge": "Gần đây",
    "imageInput.uploadBadge": "Tải lên",
    "imageInput.addToGallery": "Thêm vào thư viện",
    "imageInput.addToGalleryShort": "Thư viện ảnh",
    "imageInput.removeImage": "Xóa hình ảnh",
    "imageInput.editedBadge": "Đã chỉnh sửa",
    "imageInput.editImage": "Chỉnh sửa {name}",
    "imageInput.deletedRecent": "Đã xóa nội dung tải lên gần đây",
    "imageInput.deletedGallery": "Đã xóa hình ảnh thư viện",
    "recentAssets.defaultName": "Tải lên gần đây",
    "recentAssets.use": "Sử dụng {name}",
    "recentAssets.delete": "Xóa {name}",
    "recentAssets.deleteTitle": "Xóa nội dung tải lên gần đây?",
    "recentAssets.deleteMessage": "Thao tác này sẽ xóa hình ảnh khỏi các ảnh tải lên gần đây. Nếu nó hiện được chọn làm đầu vào hình ảnh, nó sẽ bị xóa khỏi đầu vào hiện tại. Các tác vụ trước đây tham chiếu đến lần tải lên gần đây này sẽ mất bản xem trước đầu vào đó. Phòng trưng bày công cộng không bị ảnh hưởng.",
    "recentAssets.loadFailed": "Không tải được ảnh tải lên gần đây",
    "recentAssets.deleteFailed": "Không xóa được nội dung tải lên gần đây",
    "recentAssets.deleted": "Đã xóa nội dung tải lên gần đây",
    "inputSource.uploadFallback": "Hình ảnh đã tải lên",
    "inputSource.galleryFallback": "Hình ảnh thư viện",
    "inputSource.focusPasteFallback": "{prefix}. Đầu vào hình ảnh được tập trung; nhấn {shortcut} để dán hình ảnh.",
    "inputSource.pastedCount": "Đã dán hình ảnh bảng nhớ tạm {count}",
    "inputSource.droppedCount": "Đã thêm {count} ảnh được thả",
    "inputSource.dropImagesOnly": "Chỉ thả tập tin hình ảnh",
    "inputSource.clipboardUnsupported": "Trình duyệt này không thể đọc clipboard trực tiếp",
    "inputSource.clipboardEmpty": "Không tìm thấy hình ảnh clipboard",
    "inputSource.clipboardDenied": "Trình duyệt đã chặn truy cập clipboard trực tiếp",
    "inputSource.clipboardReadFailed": "Không đọc được bảng nhớ tạm",
    "status.missingGalleryReference": "Một hình ảnh tham khảo thư viện đã bị xóa. Loại bỏ nó trước khi tạo.",
    "status.missingRecentReference": "Hình ảnh tham chiếu tải lên gần đây đã bị xóa. Loại bỏ nó trước khi tạo.",
    "status.emptyPrompt": "Nhập lời nhắc",
    "status.editNeedsImage": "Chế độ chỉnh sửa yêu cầu ít nhất một hình ảnh",
    "status.loadedTask": "Đã tải tác vụ {taskId}",
    "status.reusedTask": "Đã mở tác vụ {taskId} trong trình tạo",
    "status.loadingHistoryInputs": "Đang tải hình ảnh đầu vào lịch sử...",
    "status.historyInputLoadFailed": "Không tải được hình ảnh đầu vào lịch sử: {url}",
    "referenceCollector.alreadyStaged": "Đã tạm giữ làm ảnh tham khảo",
    "referenceCollector.staged": "Đã tạm giữ {count} ảnh tham khảo",
    "referenceCollector.title": "Tham chiếu đang chờ · {count}",
    "referenceCollector.addAll": "Thêm tất cả ảnh tham khảo",
    "referenceCollector.itemFallback": "Đang chờ tham chiếu",
    "referenceCollector.remove": "Xóa tham chiếu đang chờ xử lý",
    "referenceCollector.cleared": "Đã xóa các tham chiếu đang chờ xử lý",
    "referenceCollector.added": "Đã thêm {count} ảnh tham khảo",
    "referenceCollector.addFailed": "Không thể thêm tham chiếu đang chờ",
    "referenceCollector.readFailed": "Không đọc được hình ảnh: {status}",
    "gallery.quick": "Thư viện nhanh",
    "gallery.current": "Thư viện danh mục hiện tại",
    "gallery.categories": "Danh mục thư viện",
    "gallery.categoryPortrait": "Chân dung",
    "gallery.categoryCharacter": "Nhân vật",
    "gallery.categoryProduct": "Sản phẩm",
    "gallery.categoryPortraitRole": "Tham khảo chân dung",
    "gallery.categoryCharacterRole": "Tham khảo nhân vật",
    "gallery.categoryProductRole": "Tham khảo sản phẩm",
    "gallery.referenceRole": "Hình ảnh tham khảo",
    "gallery.manage": "Quản lý thư viện",
    "gallery.loadFailed": "Không tải được thư viện",
    "gallery.imageOrderUpdateFailed": "Không thể cập nhật thứ tự hình ảnh",
    "gallery.imageOrderUpdated": "Đã cập nhật thứ tự hình ảnh",
    "gallery.categoryName": "Tên danh mục",
    "gallery.categoryPromptRole": "Vai trò lời nhắc",
    "gallery.categorySave": "Lưu",
    "gallery.categoryDelete": "Xóa",
    "gallery.categoryLoadFailed": "Không thể tải danh mục",
    "gallery.categoryNameRequired": "Nhập tên danh mục",
    "gallery.categoryCreateFailed": "Không thể thêm danh mục",
    "gallery.categoryCreated": "Đã thêm danh mục",
    "gallery.categorySaveFailed": "Không lưu được danh mục",
    "gallery.categorySaved": "Đã lưu danh mục",
    "gallery.categoryDeleteTitle": "Xóa danh mục thư viện?",
    "gallery.categoryDeleteMessage": "Hình ảnh trong danh mục này sẽ chuyển sang danh mục khác. Hình ảnh thư viện sẽ không bị xóa.",
    "gallery.categoryDeleteConfirm": "Xóa danh mục",
    "gallery.categoryDeleteFailed": "Không thể xóa danh mục",
    "gallery.categoryDeletedMigrated": "Danh mục \"{name}\" đã bị xóa và hình ảnh đã được di chuyển",
    "gallery.categoryOrderUpdateFailed": "Không thể cập nhật thứ tự danh mục",
    "gallery.categoryOrderUpdated": "Đã cập nhật thứ tự danh mục",
    "gallery.categoryFallback": "danh mục thư viện",
    "gallery.imageFallback": "Hình ảnh thư viện",
    "gallery.imageLoadFailed": "Không thể tải hình ảnh này",
    "gallery.editImageLoadFailed": "Không thể tải hình ảnh này để chỉnh sửa",
    "gallery.cannotAddImage": "Không thể thêm hình ảnh này vào thư viện",
    "gallery.nameRequired": "Nhập tên thư viện",
    "gallery.saveFailed": "Không lưu được hình ảnh thư viện",
    "gallery.savedAsReference": "Đã thêm vào thư viện và chuyển sang tham chiếu thư viện",
    "gallery.renameImage": "Đổi tên hình ảnh thư viện",
    "gallery.moveToCategory": "Chuyển đến danh mục",
    "gallery.categoryRequired": "Chọn danh mục thư viện",
    "gallery.promptNoteTitle": "Ghi chú tham khảo thư viện",
    "gallery.updateFailed": "Không cập nhật được thư viện",
    "gallery.selectImageFile": "Chọn một tập tin hình ảnh",
    "gallery.replaceImageFailed": "Không thể thay thế hình ảnh thư viện",
    "gallery.replacedImage": "Đã thay thế hình ảnh nguồn cho \"{name}\"",
    "gallery.deleteImageTitle": "Xóa hình ảnh thư viện?",
    "gallery.deleteImageMessage": "Các tham chiếu tác vụ lịch sử sẽ hiển thị là đã bị xóa.",
    "gallery.deleteFailed": "Không thể xóa hình ảnh thư viện",
    "gallery.deletedSuffix": "(đã xóa)",
    "gallery.editImageLabel": "Chỉnh sửa hình ảnh thư viện",
    "gallery.fieldCategory": "Danh mục",
    "gallery.fieldPromptNote": "Ghi chú tham khảo",
    "gallery.fieldName": "Tên",
    "quickGallery.empty": "Không có hình ảnh {category}",
    "promptGallery.remove": "Xóa @{name}",
    "prompt.title": "Lời nhắc",
    "prompt.editorLabel": "Lời nhắc",
    "prompt.placeholder": "Mô tả hình ảnh bạn muốn tạo hoặc chỉnh sửa. Nhập @ để tham khảo thư viện, # cho mã màu và ~ cho đoạn lời nhắc.",
    "prompt.run": "Tạo",
    "prompt.runEdit": "Bắt đầu chỉnh sửa",
    "prompt.runTitle": "Tạo (Cmd+Enter)",
    "prompt.runEditTitle": "Bắt đầu chỉnh sửa (Cmd+Enter)",
    "prompt.findPanel": "Lời nhắc tìm và thay thế",
    "prompt.findText": "Tìm văn bản",
    "prompt.replaceWith": "Thay thế bằng",
    "prompt.findActions": "Hành động tìm và thay thế",
    "prompt.countZero": "0 kết quả",
    "prompt.matchCount": "{count} kết quả",
    "prompt.foundCount": "Đã tìm thấy {count} kết quả phù hợp",
    "prompt.noMatch": "Không có văn bản phù hợp",
    "prompt.replacedCount": "Đã thay thế {count} kết quả",
    "prompt.closeFind": "Đóng tìm và thay thế",
    "prompt.recentTemplates": "Mẫu gần đây",
    "prompt.manageTemplates": "Quản lý mẫu",
    "promptModel.galleryHeader": "Ghi chú hình ảnh tham khảo:",
    "promptModel.galleryInstruction": "- Ảnh tham khảo {number}: thư viện \"{name}\", vai trò: {role}. @{name} trong lời nhắc đề cập đến hình ảnh này.{note}",
    "outputSettings.title": "Đầu ra",
    "output.lock.lock": "Khóa tham số",
    "output.lock.unlock": "Mở khóa và chỉnh sửa",
    "output.lock.current": "Khóa hiện tại",
    "output.lock.task": "Tham số tác vụ đã chọn",
    "output.lock.adoptTask": "Dùng tham số tác vụ này",
    "output.lock.frame": "Khung hình",
    "output.lock.outputCount": "Số ảnh đầu ra",
    "output.lock.output": "Đầu ra",
"output.lock.search": "Tìm kiếm",
    "output.lock.call": "Lệnh gọi",
    "output.lock.sheets": "ảnh",
    "output.lock.imageModel": "Mô hình hình ảnh",
    "output.lock.prompt": "Lời nhắc",
    "output.lock.fileFormat": "Định dạng tệp",
    "output.lock.taskHint": "Chỉ đang xem tham số của tác vụ đã chọn; tham số đang khóa vẫn giữ nguyên. Việc sử dụng chúng không làm thay đổi kênh hệ thống.",
    "output.lock.lockedHint": "Tham số đã được cố định. Bấm biểu tượng khóa ở góc trên bên phải để chỉnh sửa.",
    "output.lock.enabled": "Bật",
    "output.lock.disabled": "Tắt",
    "output.lock.custom": "Tùy chỉnh",
    "output.mainModel": "Mô hình chính",
    "output.selectMainModel": "Chọn mô hình chính",
    "output.mainModelCustomForInput": "Sử dụng mô hình tùy chỉnh cho đầu vào hiện tại",
    "output.apiDirect": "API trực tiếp",
    "output.apiToolModel": "Sử dụng mô hình hình ảnh API",
    "output.mainModelUnused": "Mô hình chính không được sử dụng cho yêu cầu này",
    "output.webSearch": "Tìm kiếm trên web",
    "output.webSearchToggle": "Bật",
    "output.webSearchTitle": "Tìm kiếm web trước, rồi dùng kết quả cho lần tạo này; chỉ hỗ trợ Codex và API Responses",
    "output.promptMode": "Chế độ lời nhắc",
    "output.modeOriginal": "Bản gốc",
    "output.modeStrict": "Giữ sát lời nhắc",
    "output.modeCreative": "Sáng tạo",
    "output.promptHelp": "Xem giải thích cách xử lý lời nhắc",
    "output.promptHelpTitle": "Xử lý lời nhắc",
    "output.promptHelp.responsesChannel": "Responses · có mô hình chính tham gia",
    "output.promptHelp.imagesChannel": "Images · tạo trực tiếp",
    "output.promptHelp.responses.original": "Gửi nguyên văn của bạn cho mô hình chính và yêu cầu công cụ hình ảnh giữ nguyên từng chữ; mô hình chính vẫn có thể tạo ra lời nhắc đã sửa đổi.",
    "output.promptHelp.responses.strict": "Cho phép mô hình chính sắp xếp hoặc mở rộng lời nhắc, nhưng vẫn giữ các ràng buộc bắt buộc như đối tượng, văn bản, màu sắc và bố cục.",
    "output.promptHelp.responses.automatic": "Không thêm ràng buộc nào, để mô hình chính tự hiểu và tối ưu hóa lời nhắc trước khi gọi công cụ hình ảnh.",
    "output.promptHelp.images.original": "Ứng dụng không thêm quy tắc lời nhắc nào và gửi thẳng nguyên văn của bạn tới API hình ảnh.",
    "output.promptHelp.images.strict": "Ứng dụng gửi kèm quy tắc giữ nguyên cùng với lời nhắc gốc để nhấn mạnh mọi ràng buộc bắt buộc.",
    "output.promptHelp.images.automatic": "Dùng cách xử lý mặc định của API hình ảnh; các ghi chú tham chiếu thư viện cần thiết vẫn được gửi kèm.",
    "output.size": "Kích thước đầu ra",
    "output.sizeMode": "Chế độ kích thước",
    "output.sizePreset": "Có sẵn",
    "output.sizeCustom": "Tùy chỉnh",
    "output.orientation": "Hướng",
    "output.square": "Vuông",
    "output.portrait": "Dọc",
    "output.landscape": "Ngang",
    "output.resolution": "Độ phân giải",
    "output.pixelSize": "Kích thước pixel",
    "output.width": "Chiều rộng",
    "output.height": "Chiều cao",
    "output.swapSize": "Hoán đổi chiều rộng và chiều cao",
    "output.customSizeHint": "Đơn vị px · 16-3840 · bội số của 16 · ≤3:1",
    "output.imageSizeUnavailable": "Không có kích thước ảnh",
    "output.imageLoadFailed": "Không tải được hình ảnh",
    "output.customSizeRequired": "Nhập chiều rộng và chiều cao",
    "output.customSizeBounds": "Chiều rộng và chiều cao phải là 16-3840 px",
    "output.customSizeMultiple": "Chiều rộng và chiều cao phải là bội số của 16",
    "output.customSizeRatio": "Tỷ lệ cạnh dài và ngắn không được vượt quá 3:1",
    "output.customSizePixels": "Tổng số pixel phải là 655.360-8.294.400",
    "output.ratioLock": "Khóa tỷ lệ (tùy chọn)",
    "output.customRatio": "Tỷ lệ khung hình tùy chỉnh",
    "output.ratioWidth": "Rộng",
    "output.ratioHeight": "Cao",
    "output.firstImageRatio": "Sử dụng tỷ lệ khung hình của hình ảnh tham chiếu đầu tiên",
    "output.useFirstImage": "Theo ảnh đầu",
    "output.ratioHint": "Để trống đối với kích thước miễn phí · Điền cả hai để đồng bộ hóa",
    "output.ratio": "Tỷ lệ",
    "output.quality": "Chất lượng",
    "output.qualityAuto": "Tự động",
    "output.qualityLow": "Thấp",
    "output.qualityMedium": "Trung bình",
    "output.qualityHigh": "Cao",
    "output.quantity": "Số lượng",
    "output.pixelPreview": "Pixel đầu ra: 1024 x 1024 px",
    "output.pixelPreviewValue": "Pixel đầu ra: {value}",
    "output.pixelPreviewAuto": "Pixel đầu ra: tự động (OpenAI chọn tự động)",
    "output.format": "Định dạng",
    "output.compression": "Nén",
    "output.moderation": "Kiểm duyệt",
    "preview.title": "Xem trước",
    "preview.selectedZero": "0 đã chọn",
    "preview.selectedCount": "Đã chọn {selected}/{total}",
    "preview.downloadSelected": "Tải xuống mục đã chọn",
    "preview.deleteUnselected": "Xóa mục chưa chọn",
    "preview.downloadAll": "Tải xuống ZIP",
    "preview.empty": "Chưa có hình ảnh nào",
    "preview.taskFailed": "Tác vụ thất bại",
    "preview.partialFailed": "Một số hình ảnh không thành công",
    "preview.failedOutput": "Hình ảnh {index} không thành công",
    "preview.progressLine": "Đã hoàn thành {generated} / {total} · đã trôi qua {elapsed}",
    "preview.failureLine": "Đã hoàn thành {generated} / {total} · thất bại {failed}",
    "preview.elapsedLine": "Đã trôi qua {elapsed}",
    "preview.lastError": "Lỗi cuối cùng: {error}",
    "preview.continueGenerating": "Đang tiếp tục tạo",
    "preview.waitingContinue": "Đang chờ tiếp tục",
    "preview.retryFailed": "Thử lại hình ảnh không thành công",
    "preview.acceptSuccesses": "Chấp nhận kết quả thành công",
    "preview.generateMode": "Tạo",
    "preview.editMode": "Chỉnh sửa",
    "preview.runningTitle": "{mode} đang chạy",
    "preview.submittingTitle": "Đang gửi tác vụ",
    "preview.queuedTitle": "Tác vụ được xếp hàng đợi",
    "preview.submittingDetail": "Đang lưu đầu vào và thêm tác vụ vào hàng đợi. Quá trình tạo sẽ tự bắt đầu.",
    "preview.queuedDetail": "Tác vụ đang ở trong hàng đợi và đang chờ kênh khả dụng.",
    "preview.featured": "Đã chọn",
    "preview.addFeatured": "Chọn kết quả",
    "preview.selectedFeatured": "Đã chọn",
    "preview.removeFeatured": "Bỏ chọn kết quả",
    "preview.selectionAdded": "Đã chọn kết quả",
    "preview.selectionRemoved": "Đã bỏ chọn kết quả",
    "preview.selectionUpdateFailed": "Không thể cập nhật lựa chọn",
    "preview.noUnselectedOutputs": "Không có ảnh chưa chọn để xóa",
    "preview.deleteUnselectedTitle": "Xóa hình ảnh không được chọn?",
    "preview.deleteUnselectedMessage": "Thao tác này sẽ xóa các tệp hình ảnh cục bộ đối với các kết quả không được chọn trong tác vụ này.",
    "preview.deleteUnselectedDetail": "Giữ {selected}, xóa {deleted}",
    "preview.deleteUnselectedFailed": "Không thể xóa hình ảnh không được chọn",
    "preview.deleteUnselectedDone": "Đã xóa hình ảnh không được chọn",
    "preview.addReference": "Thêm ảnh tham khảo",
    "preview.stage": "Tạm giữ",
    "preview.stageReference": "Tạm giữ làm tham chiếu đang chờ",
    "preview.prompt": "Lời nhắc",
    "preview.download": "Tải xuống",
    "preview.downloadImage": "Tải xuống hình ảnh này",
    "lightbox.label": "Xem trước hình ảnh",
    "lightbox.close": "Đóng bản xem trước",
    "lightbox.previous": "Hình ảnh trước đó",
    "lightbox.next": "Hình ảnh tiếp theo",
    "promptPopover.title": "So sánh lời nhắc",
    "promptPopover.summary": "Bản gốc {original} · tối ưu hóa {optimized}",
    "promptPopover.original": "Lời nhắc ban đầu",
    "promptPopover.optimized": "Lời nhắc được tối ưu hóa",
    "promptPopover.charCount": "{count} ký tự",
    "promptPopover.empty": "Không có",
    "promptPopover.notReturned": "Không trả về",
    "promptPopover.noOptimized": "Không có lời nhắc tối ưu hóa nào được trả về",
    "promptPopover.submitted": "Xem lời nhắc đã gửi",
    "promptPopover.close": "Đóng so sánh lời nhắc",
    "promptPopover.copyOptimized": "Sao chép lời nhắc được tối ưu hóa",
    "promptPopover.copied": "Đã sao chép",
    "taskContext.menuLabel": "Menu ngữ cảnh tác vụ",
    "taskContext.view": "Xem tác vụ",
    "taskContext.copyId": "Sao chép Task ID",
    "taskContext.copyPrompt": "Sao chép lời nhắc",
    "taskContext.revealOutput": "Mở thư mục đầu ra",
    "taskContext.archive": "Lưu trữ tác vụ",
    "taskContext.delete": "Xóa tác vụ",
    "taskContext.idCopied": "Đã sao chép Task ID",
    "taskContext.promptCopied": "Đã sao chép lời nhắc",
    "taskContext.noPrompt": "Tác vụ này không có lời nhắc để sao chép",
    "taskContext.revealFailed": "Không thể mở thư mục đầu ra",
    "taskContext.revealOpened": "Đã mở thư mục đầu ra",
    "taskContext.actionFailed": "Thao tác tác vụ thất bại",
    "taskActions.group": "Hành động tác vụ",
    "taskActions.deleteTitle": "Xóa tác vụ?",
    "taskActions.deleteMessage": "Điều này cũng sẽ xóa các tập tin hình ảnh cục bộ.",
    "taskActions.runningCannotDelete": "Không thể xóa các tác vụ đang chạy",
    "taskActions.updated": "Đã cập nhật trạng thái tác vụ",
    "taskActions.archived": "Đã lưu trữ cuộc trò chuyện",
    "taskActions.archiveFailed": "Lưu trữ không thành công",
    "taskActions.deleted": "Đã xóa tác vụ",
    "taskActions.deleteFailed": "Xóa không thành công",
    "taskActions.noRetryableFailedImages": "Tác vụ này không có hình ảnh nào bị lỗi để thử lại",
    "taskActions.retryFailedOutputsFailed": "Không thể thử lại các hình ảnh bị lỗi",
    "taskActions.requeuedFailedImages": "Đã đưa ảnh lỗi vào hàng đợi",
    "taskActions.noAcceptableSuccessImages": "Tác vụ này không có hình ảnh thành công nào để chấp nhận",
    "taskActions.acceptSuccessesFailed": "Không thể chấp nhận kết quả thành công",
    "taskActions.acceptedSuccesses": "Đã chấp nhận kết quả thành công",
    "taskActions.viewedUpdateFailed": "Không cập nhật được trạng thái đọc",
    "taskActions.failedFallback": "Tác vụ thất bại",
    "taskList.empty": "Chưa có lịch sử",
    "taskList.selectSession": "Chọn trò chuyện",
    "taskList.unreadUpdate": "Cập nhật chưa đọc",
    "taskList.viewing": "Đang xem",
    "taskList.backToLatest": "Quay lại tác vụ mới nhất",
    "taskList.backToLatestWithCount": "Quay lại tác vụ mới nhất, có {count} tác vụ mới ở phía trên",
    "taskDerived.usageLimited": "Hạn chế sử dụng",
    "taskSubmit.requestFailed": "Yêu cầu không thành công",
    "taskSubmit.queued": "Tác vụ được thêm vào hàng đợi",
    "taskSubmit.timeout": "Gửi tác vụ hết thời gian trước khi backend phản hồi. Làm mới hàng đợi để xác nhận tác vụ đã được thêm hay chưa, rồi quyết định có thử lại không.",
    "taskSubmit.failed": "Gửi tác vụ không thành công",
    "templates.title": "Mẫu lời nhắc",
    "templates.summary": "Thư viện mẫu cục bộ",
    "templates.availableCount": "{count} mẫu khả dụng",
    "templates.noMatch": "Không có mẫu phù hợp",
    "templates.empty": "Không có mẫu",
    "templates.favoriteBadge": "Yêu thích",
    "templates.usageCount": "{count} lần dùng",
    "templates.back": "Quay lại",
    "templates.edit": "Chỉnh sửa",
    "templates.copy": "Sao chép",
    "templates.insert": "Chèn",
    "templates.formTitle": "Tiêu đề",
    "templates.formShortTitle": "Tiêu đề ngắn",
    "templates.formCategory": "Danh mục",
    "templates.formTags": "Thẻ",
    "templates.formThumbnail": "Hình thu nhỏ",
    "templates.formContent": "Nội dung",
    "templates.formNotes": "Ghi chú",
    "templates.formFavorite": "Yêu thích",
    "templates.thumbnailClear": "Xóa",
    "templates.thumbnailNone": "Chưa chọn",
    "templates.thumbnailEmpty": "Không có hình thu nhỏ lịch sử",
    "templates.newCategory": "Danh mục mới",
    "templates.search": "Tìm kiếm mẫu, thẻ hoặc nội dung",
    "templates.filter": "Bộ lọc mẫu",
    "templates.all": "Tất cả",
    "templates.categoryCommon": "Chung",
    "templates.categoryPortrait": "Chân dung",
    "templates.categoryProduct": "Sản phẩm",
    "templates.categoryRepair": "Sửa ảnh",
    "templates.categoryPoster": "Áp phích",
    "templates.categoryEcommerce": "Thương mại điện tử",
    "templates.favorite": "Yêu thích",
    "templates.recent": "Gần đây",
    "templates.category": "Danh mục",
    "templates.loadFailed": "Không tải được mẫu lời nhắc",
    "templates.useStateUpdateFailed": "Không cập nhật được trạng thái sử dụng mẫu lời nhắc",
    "templates.copied": "Đã sao chép mẫu lời nhắc",
    "templates.copyFailed": "Không sao chép được mẫu lời nhắc",
    "templates.history": "Lịch sử",
    "templates.saveFailed": "Không lưu được mẫu lời nhắc",
    "templates.saved": "Đã lưu mẫu lời nhắc",
    "templates.deleteFailed": "Không xóa được mẫu lời nhắc",
    "templates.deleted": "Đã xóa mẫu lời nhắc",
    "templates.categoryAddFailed": "Không thể thêm danh mục mẫu",
    "templates.categoryAdded": "Đã thêm danh mục mẫu",
    "templates.categorySaveFailed": "Không lưu được danh mục mẫu",
    "templates.categorySaved": "Đã lưu danh mục mẫu",
    "templates.categoryDeleteFailed": "Không thể xóa danh mục mẫu",
    "templates.categoryDeleted": "Đã xóa danh mục mẫu",
    "templates.importFailed": "Không thể nhập gói mẫu",
    "templates.importedCount": "Đã nhập {count} mẫu",
    "templates.exportFailed": "Không xuất được gói mẫu",
    "templates.exported": "Đã xuất gói mẫu",
    "snippets.suggestLabel": "Bộ chọn đoạn lời nhắc",
    "snippets.saveSelection": "Lưu",
    "snippets.saveSelectionLabel": "Lưu văn bản đã chọn dưới dạng đoạn nhắc",
    "snippets.popoverLabel": "Đoạn lời nhắc",
    "snippets.defaultCategory": "Chung",
    "snippets.loadFailed": "Không tải được đoạn lời nhắc",
    "snippets.remove": "Xóa ~{tag}",
    "snippets.expand": "Mở rộng",
    "snippets.edit": "Chỉnh sửa",
    "snippets.close": "Đóng",
    "snippets.editTitle": "Chỉnh sửa đoạn lời nhắc",
    "snippets.saveTitle": "Lưu đoạn lời nhắc",
    "snippets.shortTag": "Thẻ ngắn",
    "snippets.title": "Tiêu đề",
    "snippets.category": "Danh mục",
    "snippets.content": "Nội dung",
    "snippets.titlePlaceholder": "Sử dụng thẻ ngắn theo mặc định",
    "snippets.cancel": "Hủy",
    "snippets.save": "Lưu",
    "snippets.saveFailed": "Không lưu được đoạn lời nhắc",
    "snippets.saved": "Đã lưu đoạn lời nhắc",
    "snippets.defaultTag": "Đoạn thường dùng",
    "colors.white": "Trắng",
    "colors.black": "Đen",
    "colors.warmBeige": "Màu be ấm",
    "colors.lightGreen": "Xanh nhạt",
    "colors.brandGreen": "Xanh thương hiệu",
    "colors.peachOrange": "Cam đào",
    "colors.lightBlue": "Màu xanh nhạt",
    "colors.lightPink": "Hồng nhạt",
    "colors.loadFailed": "Không tải được cài đặt màu",
    "colors.saveFailed": "Không lưu được cài đặt màu",
    "colors.importFailed": "Không thể nhập cài đặt màu",
    "colors.importedCount": "Đã nhập màu {count}",
    "colors.recentSaveFailed": "Không lưu được các màu gần đây",
    "colors.favoriteSaveFailed": "Không lưu được màu yêu thích",
    "colors.favoriteDeleteFailed": "Không xóa được màu yêu thích",
    "colors.update": "Cập nhật",
    "colors.insert": "Chèn",
    "colors.pick": "Chọn màu",
    "colors.pickShort": "Chọn",
    "colors.hexValue": "Giá trị màu",
    "colors.pendingUpdate": "Màu sắc đã thay đổi. Nhấn vào Cập nhật để áp dụng.",
    "colors.save": "Lưu",
    "colors.exportPs": "Xuất",
    "colors.importPs": "Nhập",
    "colors.done": "Xong",
    "colors.manage": "Quản lý",
    "colors.favorites": "Màu sắc yêu thích",
    "colors.recent": "Màu sắc gần đây",
    "colors.recentLabel": "Gần đây",
    "colors.deleteFavorite": "Xóa màu yêu thích {name}",
    "colors.modify": "Chỉnh sửa màu",
    "colors.modifyValue": "Chỉnh sửa màu {value}",
    "colors.removeValue": "Xóa màu {value}",
    "taskGroup.today": "hôm nay",
    "taskGroup.yesterday": "Hôm qua",
    "taskGroup.last7": "7 ngày qua",
    "taskGroup.older": "Cũ hơn",
    "taskGroup.searchResults": "Kết quả tìm kiếm",
    "taskGroup.active": "Đang chạy",
    "taskGroup.running": "Đang chạy",
    "taskGroup.waiting": "Đang chờ",
    "taskGroup.dispatchPending": "Đang chỉ định một kênh khả dụng...",
    "taskGroup.expand": "Mở rộng {label}",
    "taskGroup.collapse": "Thu gọn {label}",
    "taskGroup.buttonLabel": "{label}, {count} tác vụ",
    "taskGroup.loadMore": "Tải thêm {count}",
    "archive.title": "Lưu trữ",
    "archive.empty": "Không có cuộc trò chuyện nào được lưu trữ",
    "archive.count": "{count} các cuộc trò chuyện được lưu trữ",
    "archive.restore": "Khôi phục",
    "archive.archiveFailed": "Lưu trữ không thành công",
    "archive.restoreFailed": "Khôi phục không thành công",
    "archive.restored": "Đã khôi phục cuộc trò chuyện",
    "archive.archiving": "Đang lưu trữ...",
    "archive.restoring": "Đang khôi phục...",
    "archive.deleting": "Đang xóa...",
    "archive.restoredCount": "Đã khôi phục các tác vụ {count}",
    "settings.title": "Lưu trữ",
    "settings.status": "Khởi động lại WebUI sau khi lưu đường dẫn lưu trữ",
    "settings.inputRoot": "Thư mục đầu vào",
    "settings.outputRoot": "Thư mục đầu ra",
    "settings.galleryRoot": "Thư mục thư viện",
    "settings.sourceDataRoot": "Thư mục dữ liệu nguồn",
    "settings.language": "Ngôn ngữ giao diện",
    "settings.languageCopy": "Lần đầu mở app, giao diện sẽ theo ngôn ngữ trình duyệt. Lựa chọn thủ công sẽ được ghi nhớ.",
    "settings.notificationsCopy": "Thông báo khi tác vụ hoàn tất hoặc thất bại. Bạn cần bật thông báo hệ thống thủ công.",
    "settings.inAppNotification": "Thông báo trong ứng dụng",
    "settings.systemNotification": "Thông báo hệ thống",
    "settings.save": "Lưu cài đặt",
    "settings.loadFailed": "Không tải được cài đặt",
    "settings.saveFailed": "Không lưu được cài đặt",
    "settings.savedRestart": "Đã lưu cài đặt lưu trữ. Khởi động lại WebUI để áp dụng.",
    "settings.saved": "Đã lưu",
    "settings.savedRestartStatus": "Đã lưu cài đặt lưu trữ. Khởi động lại WebUI để áp dụng.",
    "systemSettings.title": "Cài đặt hệ thống",
    "systemSettings.tabsLabel": "Phần cài đặt hệ thống",
    "systemSettings.apiTab": "Cài đặt API",
    "systemSettings.codexTab": "Kênh Codex",
    "systemSettings.languageTab": "Ngôn ngữ",
    "systemSettings.storageTab": "Lưu trữ & Thông báo",
    "systemSettings.networkTab": "Mạng",
    "networkEgress.mode": "Tuyến mạng",
    "networkEgress.system": "Hệ thống",
    "networkEgress.direct": "Kết nối trực tiếp",
    "networkEgress.custom": "Tùy chỉnh",
    "networkEgress.customProxy": "URL proxy tùy chỉnh",
    "networkEgress.currentRoute": "Tuyến hiện tại: {route}",
    "networkEgress.test": "Kiểm tra kết nối",
    "networkEgress.save": "Lưu và áp dụng",
    "networkEgress.saved": "Đã lưu tuyến mạng",
    "networkEgress.testSucceeded": "Kết nối thành công: {target} ({elapsed} ms)",
    "networkEgress.testFailed": "Kiểm tra kết nối thất bại",
    "networkEgress.loadFailed": "Không thể tải cài đặt mạng",
    "networkEgress.saveFailed": "Không thể lưu cài đặt mạng",
    "languageSettings.instantStatus": "Thay đổi ngôn ngữ áp dụng ngay lập tức",
    "apiSettings.title": "Cài đặt API",
    "apiSettings.status": "Cài đặt đã lưu áp dụng ngay lập tức ở chế độ API",
    "apiSettings.codexMode": "Kênh Codex",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "Provider API",
    "apiSettings.searchProviders": "Tìm kiếm tên provider",
    "apiSettings.noProviderSearchResults": "Không có provider phù hợp",
    "apiSettings.providerCount": "{count} provider",
    "apiSettings.provider": "Provider",
    "apiSettings.providerName": "Tên provider",
    "apiSettings.providerIcon": "Emoji",
    "apiSettings.providerIconPlaceholder": "Tùy chọn, ví dụ 🪄",
    "apiSettings.connectionScope": "Cài đặt kết nối",
    "apiSettings.connectionPreview": "Xem trước kết nối",
    "apiSettings.modelBindings": "Liên kết mô hình",
    "apiSettings.modelBindingsHint": "Một provider có thể liên kết đồng thời nhiều mô hình và giao thức.",
    "apiSettings.addModelBinding": "Thêm liên kết mô hình",
    "apiSettings.appendRatioPrompt": "Thêm tỷ lệ vào lời nhắc",
    "apiSettings.defaultProviderForModel": "Provider mặc định",
    "apiSettings.removeBinding": "Xóa liên kết",
    "apiSettings.catalogRequiredForBinding": "Danh mục mô hình không khả dụng nên chưa thể thêm liên kết.",
    "apiSettings.keepOneBinding": "Mỗi provider phải giữ ít nhất một liên kết mô hình.",
    "apiSettings.bindingRequiredFields": "Với mỗi liên kết, hãy chọn mô hình, nhập tên mô hình từ xa và chọn ít nhất một thao tác.",
    "apiSettings.bindingOverlap": "Thao tác {operation} của {model} bị nhiều liên kết xử lý trùng nhau.",
    "apiSettings.actualRequest": "Yêu cầu thực tế",
    "apiSettings.newProviderAction": "Provider mới",
    "apiSettings.copyProvider": "Sao chép",
    "apiSettings.copyProviderName": "Bản sao {name}",
    "apiSettings.copyProviderStatus": "Đã sao chép provider cùng key đã lưu. Chỉnh tên, mô hình hoặc thay key trước khi lưu.",
    "apiSettings.copyProviderWithoutKeyStatus": "Đã sao chép provider. Chỉnh tên, mô hình hoặc thêm API key trước khi lưu.",
    "apiSettings.sortProviders": "Sắp xếp",
    "apiSettings.finishSortProviders": "Xong",
    "apiSettings.sortProviderModeStatus": "Sắp xếp provider",
    "apiSettings.sortProviderStatus": "Thứ tự provider đã thay đổi. Đang tự động lưu...",
    "apiSettings.moveProviderUp": "Lên",
    "apiSettings.moveProviderDown": "Xuống",
    "apiSettings.moveProviderUpAria": "Di chuyển {provider} lên",
    "apiSettings.moveProviderDownAria": "Di chuyển {provider} xuống",
    "apiSettings.mode": "Chế độ yêu cầu",
    "apiSettings.images": "API hình ảnh trực tiếp",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "Trực tiếp",
    "apiSettings.imageModel": "Mô hình hình ảnh",
    "apiSettings.concurrency": "Giới hạn đồng thời của provider",
    "apiSettings.concurrencyShort": "Đồng thời",
    "apiSettings.advancedSettings": "Cài đặt nâng cao",
    "apiSettings.concurrencyValue": "{concurrency} đồng thời",
    "apiSettings.keySaved": "Đã lưu khóa API",
    "apiSettings.keyNotSet": "Khóa API chưa được đặt",
    "apiSettings.showApiKey": "Hiển thị khóa API",
    "apiSettings.hideApiKey": "Ẩn khóa API",
    "apiSettings.editProvider": "Chỉnh sửa provider",
    "apiSettings.newProviderTitle": "Provider mới",
    "apiSettings.editHint": "Bấm lưu provider để ghi thay đổi vào backend; hủy sẽ bỏ thay đổi lần này.",
    "apiSettings.finishEditFirst": "Lưu hoặc hủy chỉnh sửa provider hiện tại trước",
    "apiSettings.newDraftStatus": "Đang tạo provider. Lưu provider để áp dụng.",
    "apiSettings.editDraftStatus": "Đang chỉnh sửa provider. Lưu provider để áp dụng.",
    "apiSettings.cancelEdit": "Hủy chỉnh sửa",
    "apiSettings.saveProvider": "Lưu provider",
    "apiSettings.saveSelection": "Lưu lựa chọn",
    "apiSettings.deleteProviderTitle": "Xóa provider?",
    "apiSettings.deleteProviderMessage": "Xóa \"{provider}\"?",
    "apiSettings.deleteProviderDetail": "Thao tác này sẽ xóa provider khỏi danh sách hiện tại và tự động lưu vào backend.",
    "apiSettings.deleteProviderStatus": "Đã xóa provider. Đang tự động lưu...",
    "apiSettings.save": "Lưu cài đặt API",
    "apiSettings.loadFailed": "Không tải được cài đặt API",
    "apiSettings.savedKeyPlaceholder": "Backend đã lưu API key. Nhập key mới để thay thế.",
    "apiSettings.newProvider": "Provider mới",
    "apiSettings.saving": "Đang lưu...",
    "apiSettings.savingStatus": "Đang lưu cài đặt API...",
    "apiSettings.autoSaving": "Tự động lưu...",
    "apiSettings.autoSaved": "Tự động lưu",
    "apiSettings.saveFailed": "Không lưu được cài đặt API",
    "apiSettings.savedSummary": "Đã lưu · Codex {codex} · API {provider} · {mode} · {model} · đồng thời {concurrency}",
    "apiSettings.savedShort": "Đã lưu",
    "apiSettings.savedStatus": "Đã lưu cài đặt API",
    "apiSettings.saveFailedShort": "Lưu không thành công",
    "codexSettings.title": "Kênh Codex",
    "codexSettings.status": "Chọn kênh tạo ảnh dùng đăng nhập Codex cục bộ",
    "codexSettings.notesLabel": "Ghi chú kênh Codex",
    "codexSettings.imagesTitle": "Hình ảnh Codex",
    "codexSettings.imagesCopy": "Kênh mặc định để tạo và chỉnh sửa thông thường, với các tham số kích thước, chất lượng và chỉnh sửa được truyền trực tiếp.",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "Kênh tương thích cho các tác vụ cần tìm kiếm web hoặc chuỗi công cụ Responses.",
    "codexSettings.current": "hiện tại",
    "codexSettings.save": "Lưu kênh Codex",
    "codexSettings.saveMode": "Lưu {mode}",
    "imageEditor.title": "Chỉnh sửa hình ảnh đầu vào",
    "imageEditor.promptHint": "Các mũi tên và dấu vẽ tay trong ảnh chỉ là hướng dẫn. Không giữ chúng trong ảnh cuối cùng.",
    "imageEditor.inputFallback": "Hình ảnh đầu vào",
    "imageEditor.openFailed": "Không thể mở hình ảnh này để chỉnh sửa",
    "imageEditor.loadForEditFailed": "Không thể tải hình ảnh này để chỉnh sửa",
    "imageEditor.canvasCreateFailed": "Không tạo được canvas chỉnh sửa hình ảnh",
    "imageEditor.closedRegionRequired": "Sử dụng cọ để vẽ vùng kín trước",
    "imageEditor.saveFailed": "Không lưu được chỉnh sửa hình ảnh",
    "imageEditor.saved": "Đã lưu hình ảnh đầu vào đã chỉnh sửa",
    "imageEditor.uneditable": "Hình ảnh này không thể được chỉnh sửa",
    "imageEditor.resetDone": "Đặt lại về ảnh gốc",
    "imageEditor.resetFailed": "Không thể đặt lại ảnh gốc",
    "imageEditor.subtitle": "Cắt, vẽ, điền hoặc thêm mũi tên, sau đó lưu làm hình ảnh đầu vào mới",
    "imageEditor.toolbar": "Thanh công cụ chỉnh sửa hình ảnh",
    "imageEditor.tools": "Công cụ",
    "imageEditor.select": "Chọn",
    "imageEditor.brush": "Cọ",
    "imageEditor.arrow": "Mũi tên",
    "imageEditor.crop": "Cắt",
    "imageEditor.fill": "Tô",
    "imageEditor.fillLabel": "Tô màu bằng thùng sơn",
    "imageEditor.eraser": "Tẩy",
    "imageEditor.colors": "Màu",
    "imageEditor.red": "Đỏ",
    "imageEditor.blue": "Xanh dương",
    "imageEditor.green": "Xanh lá",
    "imageEditor.yellow": "Vàng",
    "imageEditor.white": "Trắng",
    "imageEditor.black": "Đen",
    "imageEditor.customColor": "Màu tùy chỉnh",
    "imageEditor.stroke": "Nét",
    "imageEditor.history": "Lịch sử",
    "imageEditor.undo": "Hoàn tác",
    "imageEditor.redo": "Làm lại",
    "imageEditor.reset": "Đặt lại hình ảnh",
    "imageEditor.canvas": "Canvas chỉnh sửa hình ảnh",
    "imageEditor.canvasScope": "Phạm vi canvas",
    "imageEditor.canvasScopeBase": "Hình ảnh cơ sở",
    "imageEditor.canvasScopeFit": "Vừa lớp",
    "imageEditor.canvasFitDone": "Canvas bây giờ vừa với các lớp",
    "imageEditor.canvasBaseDone": "Canvas được khôi phục về hình ảnh cơ sở",
    "imageEditor.insertImages": "Chèn hình ảnh",
    "imageEditor.layers": "Lớp",
    "imageEditor.layerUp": "Di chuyển lên",
    "imageEditor.layerDown": "Di chuyển xuống",
    "imageEditor.emptyInsertList": "Không có hình ảnh đầu vào khác",
    "imageEditor.selectLayerFirst": "Chọn một lớp trước",
    "imageEditor.baseLayer": "Hình ảnh cơ sở",
    "gallery.title": "Thư viện ảnh",
    "gallery.subtitle": "Chọn hình ảnh tham khảo cho tác vụ hiện tại",
    "gallery.manageCategories": "Quản lý danh mục",
    "gallery.categoryManager": "Quản lý danh mục thư viện",
    "gallery.categoryManagement": "Quản lý danh mục",
    "gallery.categoryCopy": "Danh mục được lưu vào thư viện; vai trò prompt mô tả cách dùng ảnh tham khảo.",
    "gallery.newCategoryName": "Tên danh mục mới",
    "gallery.newCategoryRole": "Vai trò prompt, ví dụ: tham khảo phong cách",
    "gallery.addCategory": "Thêm danh mục",
    "gallery.drawerSubtitle": "Danh mục hiện tại: {category}. Bấm \"Sử dụng\" để thêm vào ảnh đầu vào.",
    "gallery.emptyCategory": "Chưa có hình ảnh nào trong danh mục này",
    "gallery.dragSort": "Kéo để sắp xếp",
    "gallery.dragSortImage": "Kéo sắp xếp hình ảnh {name}",
    "gallery.dragSortCategory": "Kéo để sắp xếp danh mục {name}",
    "gallery.use": "Sử dụng",
    "gallery.replace": "Thay thế",
    "gallery.rename": "Đổi tên",
    "gallery.moveCategory": "Danh mục",
    "gallery.note": "Lưu ý",
    "gallery.delete": "Xóa",
    "gallery.uncategorized": "Chưa được phân loại",
    "addGallery.title": "Thêm vào thư viện",
    "addGallery.copy": "Tên là duy nhất toàn cục và có thể gọi bằng @tên sau này",
    "addGallery.name": "Tên",
    "addGallery.namePlaceholder": "Ví dụ: Mia",
    "addGallery.category": "Danh mục",
    "addGallery.note": "Ghi chú tham khảo",
    "addGallery.notePlaceholder": "Ví dụ: chỉ tham chiếu khuôn mặt và tóc, không tham chiếu quần áo hay hình nền",
    "addGallery.save": "Lưu vào thư viện",
    "close.promptTemplates": "Đóng bảng mẫu lời nhắc",
    "close.archive": "Đóng bảng lưu trữ",
    "close.settings": "Đóng bảng cài đặt bộ nhớ",
    "close.apiSettings": "Đóng bảng cài đặt API",
    "close.systemSettings": "Đóng bảng cài đặt hệ thống",
    "close.imageEditor": "Đóng bảng chỉnh sửa hình ảnh",
    "close.gallery": "Đóng bảng thư viện",
    "close.addGallery": "Đóng bảng thêm vào thư viện",
    "close.version": "Đóng bảng cập nhật phiên bản",
    "imageInput.referenceTitle": "Đầu vào tham chiếu (tùy chọn)",
    "referenceFiles.add": "Thêm tệp",
    "referenceFiles.selected": "Tệp tham chiếu",
    "referenceFiles.recent": "Tệp gần đây",
    "referenceFiles.familyPdf": "Trang + văn bản",
    "referenceFiles.familySpreadsheet": "Bảng tính",
    "referenceFiles.familyDocument": "Tài liệu",
    "referenceFiles.familyText": "Văn bản",
    "referenceFiles.visualLimit": "Tệp không phải PDF sẽ không giữ lại hình ảnh và biểu đồ nhúng. Hãy chuyển sang PDF khi cần tham chiếu bố cục.",
    "referenceFiles.remove": "Xóa tệp {filename}",
    "referenceFiles.switchTitle": "Xóa tệp tham chiếu?",
    "referenceFiles.switchMessage": "Tệp tham chiếu chỉ hoạt động với Responses. Hãy xóa các tệp đã chọn trước khi chuyển sang Images.",
    "referenceFiles.removeAndSwitch": "Xóa tệp và chuyển",
    "referenceFiles.requiresResponses": "Tệp tham chiếu chỉ hỗ trợ Responses",
    "referenceFiles.switchToResponses": "Chuyển sang Responses",
    "referenceFiles.openApiSettings": "Mở cài đặt API",
    "referenceFiles.providerMissing": "Provider Responses của tác vụ gốc không khả dụng. Hãy chọn provider trong cài đặt API.",
    "referenceFiles.missing": "Không tìm thấy tệp",
    "referenceFiles.loadFailed": "Không tải được tệp tham chiếu",
    "referenceFiles.errorEmpty": "Tệp tham chiếu trống",
    "referenceFiles.errorUnsupported": "Không hỗ trợ định dạng tệp tham chiếu này",
    "referenceFiles.errorMismatch": "Nội dung tệp không khớp với phần mở rộng",
    "referenceFiles.errorInvalid": "Tệp tham chiếu không hợp lệ",
    "referenceFiles.errorTooLarge": "Mỗi tệp tham chiếu phải nhỏ hơn 50 MB",
    "referenceFiles.errorTotalTooLarge": "Tổng dung lượng tệp tham chiếu không được vượt quá 50 MB",
    "referenceFiles.errorMissing": "Một tệp tham chiếu đã chọn không còn tồn tại",
    "referenceFiles.errorProviderUnsupported": "Responses của provider hiện tại không hỗ trợ tệp tham chiếu",
    "referenceFiles.responsesEnabled": "Đã chuyển sang Responses",
    "referenceFiles.historyPathMismatch": "Các tệp tham chiếu này dùng những đường dẫn Responses khác nhau",
    "history.referenceFiles": "Tệp tham chiếu",
    "history.downloadReferenceFile": "Tải xuống tệp",
    "history.readdReferenceFile": "Thêm lại",
    "modelSelection.family": "Dòng mô hình",
    "modelSelection.concreteModel": "Mô hình",
    "modelSelection.provider": "Provider",
    "modelSelection.providerUnavailable": "Không có provider khả dụng cho mô hình này",
    "modelSelection.openSettings": "Mở cài đặt provider",
    "modelSelection.codexUnavailable": "Đăng nhập Codex không khả dụng",
    "modelSelection.catalogUnavailable": "Danh mục mô hình không khả dụng",
    "output.background": "Nền",
    "canvas.aspectRatio": "Tỷ lệ khung hình",
    "canvas.resolution": "Độ phân giải",
    "gemini.googleSearch": "Tìm kiếm Google",
    "gemini.googleImageSearch": "Tìm kiếm hình ảnh Google",
    "output.modalities": "Phương thức đầu ra",
    "gemini.safetySettings": "Cài đặt an toàn",
    "gemini.safety.harassment": "Quấy rối",
    "gemini.safety.hateSpeech": "Ngôn từ thù ghét",
    "gemini.safety.sexuallyExplicit": "Nội dung khiêu dâm",
    "gemini.safety.dangerousContent": "Nội dung nguy hiểm",
    "gemini.safety.threshold.unspecified": "Mặc định",
    "gemini.safety.threshold.off": "Tắt bộ lọc",
    "gemini.safety.threshold.blockNone": "Không chặn",
    "gemini.safety.threshold.blockOnlyHigh": "Chặn mức cao",
    "gemini.safety.threshold.blockMediumAndAbove": "Chặn mức trung bình+",
    "gemini.safety.threshold.blockLowAndAbove": "Chặn tất cả",
    "grounding.title": "Nguồn tìm kiếm Google",
    "grounding.searchSuggestions": "Gợi ý tìm kiếm Google",
    "grounding.sourceCount": "{count} nguồn",
    "grounding.source": "Nguồn {index}",
    "modelParameters.invalidValue": "Giá trị tham số không hợp lệ",
    "modelParameters.objectRequired": "Nhập một đối tượng JSON",
    "modelParameters.invalidJson": "Định dạng JSON không hợp lệ",
    "modelParameters.migrated": "Đã điều chỉnh {count} tham số cũ cho phù hợp với mô hình hiện tại",
    "modelParameters.historyConfiguration": "Cấu hình lịch sử",
    "modelParameters.legacyTask": "Tác vụ phiên bản cũ"
};
